export default "/images/99d3c27377b59caac3096d204b378e22.avif";